module.exports = __webpack_public_path__ + "static/media/job-icon-sprite.a21dca03.png";